var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5634_34483",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5634_34483)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6254 7.50722C17.8457 7.1693 17.0177 7 16.1402 7C14.4505 7 13.1673 7.61235 12.2897 8.83567V7.19319H9V24.0992H12.2897V13.2791C12.2897 12.8128 12.3793 12.378 12.5584 11.9752C12.8991 11.1621 13.5459 10.5125 14.3617 10.1641C14.7935 9.98498 15.2574 9.89441 15.7255 9.89789C16.1859 9.89589 16.6419 9.98646 17.0659 10.1641C17.4755 10.3326 17.848 10.5786 18.1625 10.8884C18.4877 11.195 18.7448 11.5653 18.9175 11.9759C19.0966 12.378 19.1861 12.8128 19.1861 13.2798C19.1898 13.7373 19.1011 14.191 18.9253 14.6141C18.7495 15.0371 18.4902 15.4212 18.1625 15.7435C17.8479 16.053 17.4754 16.2988 17.0659 16.4671C16.6437 16.6446 16.1967 16.7333 15.7255 16.7333C15.2633 16.7316 14.8067 16.6327 14.3858 16.4432L14.3617 16.4193L13.1425 18.6414V18.6653C13.9388 19.309 14.9382 19.6312 16.1402 19.6312C16.9928 19.6361 17.8377 19.472 18.6254 19.1486C19.3798 18.8276 20.0663 18.3686 20.6491 17.7956C21.2343 17.215 21.6978 16.5255 22.013 15.7667C22.3565 14.9821 22.5308 14.135 22.5248 13.2798C22.5248 12.4101 22.3539 11.597 22.013 10.84C21.6967 10.0958 21.2327 9.42234 20.6484 8.85956C20.0744 8.27652 19.3859 7.81627 18.6254 7.50722Z",
    fill: "#121212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logoSmall.4d5d2d189a5b49c50ab978dce2db423a.svg";
export { ForwardRef as ReactComponent };